import { render, staticRenderFns } from "./SKUDiscountSettings.vue?vue&type=template&id=494ca452&scoped=true&"
import script from "./SKUDiscountSettings.vue?vue&type=script&lang=js&"
export * from "./SKUDiscountSettings.vue?vue&type=script&lang=js&"
import style0 from "./SKUDiscountSettings.vue?vue&type=style&index=0&id=494ca452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494ca452",
  null
  
)

export default component.exports